import React from 'react';
import { Field, Form, Formik } from 'formik';
import { Grid } from '@material-ui/core';
import { isNil } from 'ramda';
import { cFieldNames, validationSchema } from './schema';
import { AuditTypeLayout, CreateAuditTypeLayout } from '../../types/AuditTypeLayoutApiResponse';
import { IForm } from '../../types/IForm';
import FieldText from '../../components/Form/FieldText';
import { SubmitButton } from '../../components/Form/SubmitButton';
import { useTranslation } from '../../contexts/translationContext';

interface Props extends IForm {
    onSubmit: (values: any) => void;
    buttonTitle?: string;
    data?: AuditTypeLayout;
}

export const AuditTypeLayoutForm = ({
    onSubmit,
    data,
    buttonTitle,
    userCanEdit,
    goBackUrl,
}: Props) => {
    const { t } = useTranslation();
    const initialValues: CreateAuditTypeLayout = {
        id: 0,
        name: '',
        description: '',
    };
    return (
        <Formik
            enableReinitialize
            initialValues={isNil(data) ? initialValues : data}
            validationSchema={validationSchema(t)}
            onSubmit={(values) => {
                onSubmit(values);
            }}
        >
            {({ handleChange, handleSubmit }) => (
                <Form onSubmit={handleSubmit} onChange={handleChange}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} />
                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                name={cFieldNames.name}
                                label={t('Master-data.audit-types-layouts.detail.input-1')}
                                fullWidth
                                component={FieldText}
                                disabled={!userCanEdit}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                name={cFieldNames.description}
                                label={t('Master-data.audit-types-layouts.detail.input-2')}
                                fullWidth
                                value={
                                    data?.description === null
                                        ? initialValues.description
                                        : data?.description
                                }
                                component={FieldText}
                                disabled={!userCanEdit}
                            />
                        </Grid>
                        <SubmitButton
                            visible={userCanEdit}
                            goBackUrl={goBackUrl}
                            buttonTitle={buttonTitle}
                        />
                    </Grid>
                </Form>
            )}
        </Formik>
    );
};
